import { WeightLifterIcon } from './WeightLifterIcon';

/**
 * author: Michael Irigoyen
 * id 4ECFBE4E-52B2-4A60-BD6C-9B7DAB38E7A5
 * name weight-lifter
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weight-lifter.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanBarbellIcon = WeightLifterIcon;
export default HumanBarbellIcon